import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import PageLayout from '@/components/layout/PageLayout';
import { Button } from '@/components/ui/button';

const isSafeHttpUrl = (value?: string | null) => {
  if (!value) return false;
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};

const Leaving: React.FC = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const to = params.get('to') || '';
  const safe = isSafeHttpUrl(to);

  return (
    <PageLayout>
      <div className="container max-w-lg mx-auto py-12 px-4">
        <h1 className="text-2xl font-semibold mb-4">You're leaving FOMO</h1>
        <p className="text-sm text-[#b3b3b3] mb-6">
          You clicked a link that will take you to an external website. This link was provided by a creator.
        </p>
        <div className="bg-[#171718] border border-[#343536] rounded-lg p-4 mb-6 break-words">
          <div className="text-xs uppercase tracking-wider text-[#818384] mb-2">Destination</div>
          <div className="text-[#D7DADC] text-sm">{safe ? to : 'Invalid or unsupported URL'}</div>
        </div>
        <div className="flex gap-3">
          <Button variant="secondary" onClick={() => navigate(-1)}>Go Back</Button>
          <Button
            className="bg-[#272729] hover:bg-[#2D2D2F] text-[#D7DADC] border border-[#343536]"
            disabled={!safe}
            onClick={() => {
              if (safe) {
                window.location.href = to;
              }
            }}
          >
            Proceed
          </Button>
        </div>
      </div>
    </PageLayout>
  );
};

export default Leaving;
